import { render, staticRenderFns } from "./BulkChangeVideoPrivacy.vue?vue&type=template&id=0e0c1cf7&"
import script from "./BulkChangeVideoPrivacy.vue?vue&type=script&lang=js&"
export * from "./BulkChangeVideoPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports